export const HELVETICA = "Classic";
export const HELVETICA_NARROW = "Classic Narrow";
export const HELVETICA_BOLD = "Classic Bold";
export const HELVETICA_NARROW_BOLD = "Classic Narrow Bold";
export const BARLOW_CONDENSED_MEDIUM = "Geometric Condensed Medium";
export const BARLOW_CONDENSED_BOLD = "Geometric Condensed Bold";
export const BARLOW_CONDENSED_BOLDER = "Geometric Condensed Bolder";
export const AVENIR_NEXT_LIGHT = "Modern Light";
export const AVENIR_NEXT_MEDIUM = "Modern Medium";
export const AVENIR_NEXT_BOLD = "Modern Bold";
export const AVENIR_NEXT_CONDENSED_MEDIUM = "Modern Condensed Medium";
export const AVENIR_NEXT_CONDENSED_BOLD = "Modern Condensed Bold";
export const AVENIR_NEXT_CONDENSED_BOLDER = "Modern Condensed Bolder";
export const CRIMSONPRO_MEDIUM = "Traditional Medium";
export const CRIMSONPRO_BOLD = "Traditional Bold";
export const CRIMSONPRO_BOLDER = "Traditional Bolder";
